import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import './ScatterDetailModal.css'
import { Modal, Pagination, message } from 'antd'
import closeImg from '../static/closeImg.png'
import { SampleAttributeCompareTable, ScatterProductAttributeCompareTable } from '../Public/PublicData'
// import sampleThunb from '../static/sampleThunb.png'
import ScatterChart from './ScatterChart'

class ScatterDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sampleThumbnailsPath: '',//样本缩略图路径
            samplePropetyComparisionArray: [],//样本属性参数数组
            productPropetyComparisionArray: [],//产品参数数组
        }
    }

    componentDidMount() {
        console.log(this.props.selcetItem)
        this.getMicroRSFeatureGraphicPath()
        this.handleParamsComparisionTable()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.selcetItem !== prevProps.selcetItem) {
            this.getMicroRSFeatureGraphicPath()
            this.handleParamsComparisionTable()
        }
    }

    /**
     * @description: 处理对照表
     * @event: paramsComparisionTable
     * @return {*}
     */

    handleParamsComparisionTable = () => {
        const { samplePropetyComparision, productPropetyComparision } = this.props
        if (samplePropetyComparision) {
            let samplePropetyName = samplePropetyComparision.field_meaning.split(',')
            let samplePropetyValue = samplePropetyComparision.field_name.split(',')
            let tempArray = [samplePropetyName, samplePropetyValue]
            this.setState({
                samplePropetyComparisionArray: tempArray
            }, () => {
                console.log('samplePropetyComparisionArray:', this.state.samplePropetyComparisionArray)
            })
        }
        if (productPropetyComparision) {
            let productPropetyName = productPropetyComparision.field_meaning.split(',')
            let productPropetyValue = productPropetyComparision.field_name.split(',')
            let tempArray = [productPropetyName, productPropetyValue]
            this.setState({
                productPropetyComparisionArray: tempArray
            }, () => {
                console.log("productPropetyComparisionArray:", this.state.productPropetyComparisionArray)
            })
        }
    }
    /**
     * @description: 获取样本缩略图地址
     * @event: getMicroRSFeatureGraphicPath
     * @return {*}
     */
    getMicroRSFeatureGraphicPath = async () => {
        const { zd_user } = this.props
        if (this.props.selcetItem) {
            let dataNamesArray = []
            dataNamesArray.push(this.props.selcetItem.product_name + '.zip')
            let dataPath = this.props.selcetItem.sample_photo_file_location.replace(/\\/g, '%5C')
            const { data: res } = await axios.get(`/zdUrl/api/getMicroRSFeatureGraphicPath?dataNames=${dataNamesArray}&dataPath=${dataPath}`, {
                headers: {
                    Authorization: zd_user.token,
                }
            })
            // console.log('getMicroRSFeatureGraphicPath', res)
            if (res.code === '0') {
                let dataNames = this.props.selcetItem.product_name + '.zip'
                this.setState({
                    sampleThumbnailsPath: res.data[dataNames].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles")
                })
            } else {
                message.error("样本图片获取失败")
            }
        } else {
            return null;
        }
    }
    /**
     * @description: 关闭Scatter详情弹窗
     * @event: closeScatterModal
     * @return {*}
     */
    closeScatterModal = () => {
        this.props.closeDetailModal()
    }

    render() {
        const { selcetItem } = this.props
        const { sampleThumbnailsPath } = this.state
        return (
            // <Modal
            //     className="scatter-detail-display-modal"
            //     header={null}
            //     visible={this.props.isVisible}
            //     footer={null}
            //     closable={false}
            // >
            //     <div className="scatter-detail-display-modal-hedar-wrap">
            //         <div className="scatter-detail-display-modal-hedar-title">散射产品详情展示</div>
            //         <img src={closeImg} className="scatter-detail-display-modal-hedar-closeImg"
            //              onClick={() => this.closeScatterModal()}></img>
            //     </div>
            <div className="scatter-detail-display-modal-content-wrap">
                <div className="scatter-detail-display-modal-content-top-wrap">
                    <div className="scatter-detail-display-modal-content-top-left-wrap">
                        <div className="scatter-detail-display-modal-content-top-left-sample-attribute-wrap">
                            <div
                                className="scatter-detail-display-modal-content-top-left-sample-attribute-title">样本属性参数
                            </div>
                            <div className="scatter-detail-display-modal-content-top-left-sample-attribute-content">
                                <div className="scatter-detail-display-modal-content-left-top-attributewrap">
                                    {
                                        this.state.samplePropetyComparisionArray[0] && this.state.samplePropetyComparisionArray[0].map(element => {
                                            return <div
                                                className="scatter-detail-display-modal-content-left-top-attribute-name"
                                                key={element} title={element}>{element}：</div>
                                        })
                                    }
                                </div>
                                <div className="scatter-detail-display-modal-content-left-top-resultwrap">
                                    {
                                        this.state.samplePropetyComparisionArray[1] && this.state.samplePropetyComparisionArray[1].map(element => {
                                            return <div
                                                className="scatter-detail-display-modal-content-left-top-attribute-value"
                                                key={element} title={selcetItem[element]}>{selcetItem[element]}</div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="scatter-detail-display-modal-content-top-left-produce-attribute-wrap">
                            <div
                                className="scatter-detail-display-modal-content-top-left-produce-attribute-title">散射产品参数
                            </div>
                            <div
                                className="scatter-detail-display-modal-content-top-left-produce-attribute-content">
                                <div className="scatter-detail-display-modal-content-left-bottom-attributewrap">
                                    {
                                        this.state.productPropetyComparisionArray[0] && this.state.productPropetyComparisionArray[0].map(element => {
                                            return <div
                                                className="scatter-detail-display-modal-content-left-bottom-attribute-name"
                                                key={element} title={element}>{element}：</div>
                                        })
                                    }
                                </div>
                                <div className="scatter-detail-display-modal-content-left-bottom-resultwrap">
                                    {
                                        this.state.productPropetyComparisionArray[1] && this.state.productPropetyComparisionArray[1].map(element => {
                                            return <div
                                                className="scatter-detail-display-modal-content-left-bottom-attribute-value"
                                                key={element} title={selcetItem[element]}>{selcetItem[element]}</div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="scatter-detail-display-modal-content-top-right-wrap">
                        <div className="scatter-detail-display-modal-content-top-right-img-title">样本照片</div>
                        <img src={
                            sampleThumbnailsPath ?
                                sampleThumbnailsPath.replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles") :
                                null
                        }
                            className="scatter-detail-display-modal-content-top-right-img"></img>
                        {/* <Pagination
                                className="scatter-detail-display-modal-content-left-bottom-pagination"
                                simple
                                total={13}
                                defaultPageSize={1}
                            ></Pagination> */}
                    </div>
                </div>
                <div className="scatter-detail-display-modal-content-bottom-wrap">
                    <div className="scatter-detail-display-modal-content-bottom-title">散射曲线</div>
                    <div className="scatter-detail-display-modal-content-bottom-echars-wrap">
                        <ScatterChart
                            token={this.props.zd_user.token}
                            nowSelectData={selcetItem}
                        ></ScatterChart>
                    </div>
                </div>
            </div>
            // </Modal>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
export default connect(mapState)(ScatterDetailModal)